<template>
  <wrap-container>
    <help-title title="Desconocimiento de consumo" />

    <help-list-container>
      <help-list-item
        tituloLista="Podes hacer la denuncia / desconocimiento de consumos con la
        marca de tu Tarjeta de Crédito:"
      >
        - Tarjeta de Crédito Visa: Classic 4379-3400 - Oro 4378-4444 - Platino
        0-800-333-7528 - Firma 0-800-222-7446.<br />
        Visa Home - Ingresa con tu usuario y clave menú "Gestionar" - "Denuncia"
        - <br />
        Tarjeta de Crédito MasterCard: Classic 4348-7000 - Gold 4348-7007 -
        Platinum: 0800-999-3999 - Black: 0800-999-3297.<br />
        ⚠ En caso de ser necesario, la marca bloqueará la tarjeta y emitirá un
        nuevo plástico que recibirás en tu domicilio registrado en el banco.
      </help-list-item>
      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <contact-link />
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import ContactLink from "@/components/core/ContactLink";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    ContactLink
  }
};
</script>
